import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { catchError, of } from "rxjs";
import { environment } from "../../../environments/environment";

interface DsStatusResponse {
    status?: string;
    tag?: string;
    ereg_version?: string;
    branch?: string;
    version?: string;
}

@Injectable()
export class VersionService {
    public BUILD_TYPE: string | undefined;
    public EREGISTRATIONS_VERSION: string | undefined;
    public BRANCH_NAME: string | undefined;

    constructor(private http: HttpClient) {}

    public static statusUrl(eRegistrationsUrl: string): string {
        const trimmed = (eRegistrationsUrl || "").replace(/\/+$/, "");
        return `${trimmed}/backend/status`;
    }

    public async load(): Promise<void> {
        const url = VersionService.statusUrl(environment.E_REGISTRATIONS_URL);
        const res = await firstValueFrom(
            this.http
                .get<DsStatusResponse>(url)
                .pipe(catchError(() => of(null as DsStatusResponse | null))),
        );
        if (res) {
            this.BUILD_TYPE = res.tag;
            this.EREGISTRATIONS_VERSION = res.ereg_version;
            this.BRANCH_NAME = res.branch;
        }
    }
}
